import { connect } from 'umi';
import React, { useState } from 'react';
import { Layout } from "tea-component";

import NoSpendKeyPerformanceMetrics from './components/NoSpendKeyPerformanceMetrics';
import NoSpendEngagementTrend from './components/NoSpendEngagementTrend';
import NoSpendOverallPerformance from './components/NoSpendOverallPerformance';
import NoSpendRankTop from './components/NoSpendRankTop';
import NoSpendFilter from '@/pages/dashboard/filterPageComponents/ua/noSpendFilterNew';
import { useBuriedPoint } from "@/pages/home/utils/customHook";
import { FORM_MAP } from './_config/constant';

import '@/pages/dashboard/assets/scss/page/Ua/ua.scss';
import './noSpend.scss';
import MarqueeInfo from "@/pages/dashboard/components/MarqueeInfo";
import { SubTitle } from '../../components/SubTitle';

const { Content } = Layout;

function NoSpend(props: any) {
  const { gameCode, explainInfo } = props;
  const [formValue, setFormValue] = useState<any>({
    filterValue: null,
    newFilter: true,
    timeType: 'Day',
    [FORM_MAP.RANGE_TIME_DIFF]: false
  });
  const [filterLoading, setFilterLoading] = useState(true);

  // 打点信息
  const logObj = {
    pageId: '201201',
    pageName: 'uaNoSpend',
    extInfo: 'uaNoSpend',
    pagePath: '/ua/noSpend',
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };
  useBuriedPoint(logObj);


  const handleConfirm = async (value: any) => {
    setFormValue({
      ...value,
      [FORM_MAP.IS_INIT]: false,
    }); // 设置筛选器参数
  };
  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
    setFilterLoading(false);
  };

  return (
    <Content className='ua dbd-ua-box dbd-scroll-body'>
      <Content.Header title="UA" subtitle={<SubTitle/>} />

      <Content.Body full>
        <MarqueeInfo pagePath={"/ua/noSpend"}/>
        <NoSpendFilter
          openSticky={true}
          gameCode={gameCode}
          buttonLogConfig={{ pageId: '201201',confirmButtonId: '201201001',resetButtonId: '201201002'}}
          filterConfirm={handleConfirm}
          filterReset={handleConfirm}
          filterInit={handleInit}
          setFilterLoading={setFilterLoading}
        />
        <NoSpendKeyPerformanceMetrics
          explainInfo={explainInfo}
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
        <NoSpendEngagementTrend
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
        <NoSpendOverallPerformance
          explainInfo={explainInfo}
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
        <NoSpendRankTop
          explainInfo={explainInfo}
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
      </Content.Body>
    </Content>
  );
}

export default connect((state: any) => ({
  explainInfo: state.dashboard?.explainInfo,
  gameCode: state.dashboard?.currentGame?.game_code,
}))(NoSpend);